import { GraduationCap, Envelope, Phone, IdentificationCard, Briefcase, DoorOpen } from '@phosphor-icons/react';
import PushToggleCard from '../../../components/dashboard/PushToggleCard';

const TeacherProfile = ({ me }) => (
  <div className="p-4 space-y-4" data-testid="teacher-profile">
    <div className="bg-gradient-to-br from-[#0052FF] to-[#3B82F6] rounded-xl p-6 text-white text-center">
      <div className="mx-auto h-24 w-24 rounded-full bg-white/20 border-4 border-white/30 flex items-center justify-center overflow-hidden mb-3">
        {me.photo_base64 ? (
          <img src={me.photo_base64} alt="" className="h-full w-full object-cover" />
        ) : (
          <GraduationCap size={40} weight="duotone" />
        )}
      </div>
      <h2 className="font-outfit text-xl font-bold" data-testid="profile-name">
        {me.first_name} {me.last_name}
      </h2>
      <p className="text-sm opacity-90">{me.function || 'Enseignant(e)'}</p>
    </div>

    <div className="bg-white rounded-xl border border-[#E2E8F0] divide-y divide-[#F1F5F9]">
      <InfoRow icon={IdentificationCard} label="ID Enseignant" value={me.teacher_id} mono />
      {me.subject && <InfoRow icon={Briefcase} label="Matière principale" value={me.subject} />}
      {me.email && <InfoRow icon={Envelope} label="Email" value={me.email} />}
      {me.contact && <InfoRow icon={Phone} label="Contact" value={me.contact} />}
      <InfoRow
        icon={DoorOpen}
        label="Classes assignées"
        value={me.classes.length > 0 ? me.classes.join(', ') : 'Aucune'}
      />
    </div>

    <PushToggleCard />

    <div className="text-center pt-2">
      <p className="text-xs text-[#94A3B8]">
        Pour toute modification, contactez l&apos;administration.
      </p>
    </div>
  </div>
);

const InfoRow = ({ icon: Icon, label, value, mono }) => (
  <div className="flex items-center gap-3 p-4">
    <div className="h-9 w-9 rounded-lg bg-[#EFF6FF] flex items-center justify-center">
      <Icon size={18} className="text-[#0052FF]" weight="duotone" />
    </div>
    <div className="flex-1 min-w-0">
      <div className="text-[10px] uppercase text-[#94A3B8] font-medium">{label}</div>
      <div className={`text-sm text-[#0F172A] truncate ${mono ? 'font-mono' : 'font-manrope'}`}>
        {value}
      </div>
    </div>
  </div>
);

export default TeacherProfile;
